import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CommonService } from './services/shared/common.service';
import { LanguageService } from './services/shared/language.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ClientApp';
  constructor(private _router: Router,
    private cs: CommonService,
    private languageService: LanguageService,
    
    private router: Router,
    private commonService: CommonService
  ) {
 
    languageService.checkLanguage();
  }
}
